import { Routes, Route } from "react-router-dom";
import useAdminRoutes from "./admin";
import useProvRoutes from "./provisioning";
import useHermesRoutes from "./hermes";

import Home from '../pages/Home';
import LoginPage from '../pages/provisioning/login/LoginPage';
import LoginAdminPage from '../pages/admin/login/LoginPage';
import Verify2FAPage from '../pages/admin/login/Verify2FA';
import Recover from '../pages/provisioning/recovery';
import ChangePassword from '../pages/provisioning/recovery/changePassword';
import NotFound from '../pages/NotFound';


export default function () {
    const ProvisioningRoutes = useProvRoutes();
    const AdminRoutes = useAdminRoutes();
    const HermesRoutes = useHermesRoutes();
    return (

        <Routes>
            <Route path="/" element={<Home />} />
            {HermesRoutes}
            {ProvisioningRoutes}
            {AdminRoutes}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/admin/login" element={<LoginAdminPage />} />
            <Route path="/admin/2fa" element={<Verify2FAPage />} />
            <Route path="/recovery" element={<Recover />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    )

}

